<section aria-label="Stand der Berechnung">
  <div class="mb-3 flex min-h-8 flex-wrap items-center gap-3">
    <h2 class="text-base font-bold">Stand der Berechnung</h2>
    <span class="flex-1"></span>
    <label class="inline-flex cursor-pointer items-center gap-2 text-dense text-muted-foreground">
      <hlm-switch aria-label="Technische Schritte zeigen" [checked]="technical()" (checkedChange)="technical.set($event)" />
      Technische Schritte zeigen
    </label>
    @if (store.canStart()) {
      <button hlmBtn type="button" size="sm" [disabled]="store.running()" (click)="store.openRun()">Neue Berechnung</button>
    }
  </div>

  @if (store.run(); as run) {
    <div class="mb-4 flex min-h-8 flex-wrap items-center gap-3" role="status">
      <span class="inline-flex h-6 items-center gap-1.5 rounded-md bg-primary/10 px-2 font-mono text-2xs text-primary"><span class="size-1.5 rounded-full bg-primary" aria-hidden="true"></span>Läuft</span>
      <span class="text-dense font-bold">{{ run.label }}</span>
      <span class="font-mono text-dense">{{ run.done | number: '1.0-0' : 'de-DE' }} / {{ run.total | number: '1.0-0' : 'de-DE' }}</span>
      @if (run.errors) { <span class="text-xs text-danger">{{ run.errors | number: '1.0-0' : 'de-DE' }} Fehler</span> }
      <span class="text-xs text-muted-foreground">Gestartet: {{ run.startedAt | date: 'dd.MM., HH:mm' }}</span>
      <span class="flex-1"></span>
      @if (store.canStart()) {
        <button hlmBtn type="button" variant="outline" size="sm" [disabled]="store.cancelling()" (click)="cancel()">Abbrechen</button>
      }
    </div>
  }

  <div class="border-b border-border pb-5">
    <app-step-timeline [steps]="steps()" [config]="timelineConfig" (stepHover)="onHover($event)" (stepClick)="runTo($event)" (nodeActionClick)="runTo($event)" />
    @if (store.canStart() && !store.running()) {
      <p class="mt-2 text-xs text-muted-foreground">Klicken Sie auf den Schritt, bis zu dem gerechnet werden soll.</p>
    }
  </div>
</section>

<section aria-label="Verlauf">
  <div class="mb-3 flex min-h-8 items-center gap-3">
    <h2 class="text-base font-bold">Verlauf</h2>
    @if (store.runs().length) { <span class="text-xs text-muted-foreground">{{ store.runs().length }} Berechnungen</span> }
  </div>
  @if (store.runsError()) { <app-inline-notice tone="error" [message]="store.runsError()" /> }
  <app-data-table
    [data]="displayRuns()"
    [rowId]="getRunId"
    [columns]="columns()"
    [isLoading]="store.runsLoading() && !store.runs().length"
    [showAddButton]="false"
    [showLimitFilter]="false"
    [showSearch]="false"
    [pageSize]="20"
    emptyStateTitle="Noch keine Berechnung"
    emptyStateDescription="Legen Sie mit „Neue Berechnung“ fest, was gerechnet werden soll."
    (rowClick)="store.runDetailId.set($event.runId)"
  />
</section>

<ng-template #runTpl let-run>
  <span class="flex min-w-0 flex-col">
    <span class="truncate">{{ kind(run) }}</span>
    <span class="truncate text-xs text-muted-foreground">{{ run.createdAt | date: 'dd.MM., HH:mm' }} · {{ duration(run) }} · {{ run.createdBy.name ?? '–' }}</span>
  </span>
</ng-template>
<ng-template #resultTpl let-run>
  @let parts = stagesOf(run);
  <span class="flex min-w-48 flex-col gap-1.5">
    <span class="flex h-1.5 gap-px overflow-hidden rounded-[2px] bg-muted" role="img" [attr.aria-label]="summaryOf(run)">
      @for (part of parts; track part.stage) {
        <span style="flex-basis: 0" [style.flex-grow]="part.count" [style.background-color]="part.color"></span>
      }
    </span>
    @if (parts.length) {
      <span class="flex flex-wrap gap-x-2.5 text-xs text-muted-foreground" [hlmTooltipTrigger]="summaryOf(run)">
        @for (part of parts; track part.stage) {
          <span class="inline-flex items-center gap-1 whitespace-nowrap"><span class="size-1.5 rounded-full" [style.background-color]="part.color" aria-hidden="true"></span>{{ part.count | number: '1.0-0' : 'de-DE' }} {{ part.label }}</span>
        }
      </span>
    } @else {
      <span class="line-clamp-1 text-xs text-muted-foreground" [title]="summary(run)">{{ summary(run) }}</span>
    }
  </span>
</ng-template>
<ng-template #statusTpl let-run>
  <span class="inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-md px-2 font-mono text-2xs" [class]="status(run).classes">
    <span class="size-1.5 rounded-full bg-current" aria-hidden="true"></span>{{ status(run).label }}
  </span>
</ng-template>
<ng-template #actionTpl let-run>
  @if (next(run); as action) {
    <button type="button" class="whitespace-nowrap text-xs text-primary hover:underline" (click)="action.go(); $event.stopPropagation()">{{ action.label }}</button>
  }
</ng-template>
